import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
var _excluded = ["action", "optionalLabel", "children", "label", "labelProps", "error", "message", "id"];
import React, { forwardRef } from 'react';
import system from '../../system';
import Box from '../Box';
import Label from '../Label';
import Message from '../Message';
var SYSTEM_PROPS = ['marginProps', 'floatProps'];
var Fieldset = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var action = _ref.action,
      optionalLabel = _ref.optionalLabel,
      children = _ref.children,
      label = _ref.label,
      labelProps = _ref.labelProps,
      error = _ref.error,
      message = _ref.message,
      id = _ref.id,
      props = _objectWithoutPropertiesLoose(_ref, _excluded);

  var _system = system(props, SYSTEM_PROPS),
      className = _system[0],
      style = _system[1],
      rest = _system[2];

  var fontWeight = labelProps && labelProps.fontWeight ? labelProps.fontWeight : 'bold';
  return /*#__PURE__*/React.createElement("fieldset", _extends({
    className: className,
    style: style,
    ref: ref
  }, rest), /*#__PURE__*/React.createElement(Box, {
    pb: 5
  }, /*#__PURE__*/React.createElement(Label, _extends({}, labelProps, {
    as: "legend",
    fontWeight: fontWeight,
    optional: optionalLabel,
    action: action
  }), label), message && /*#__PURE__*/React.createElement(Box, {
    mt: 2
  }, /*#__PURE__*/React.createElement(Message, {
    error: error
  }, message))), children);
});
Fieldset.displayName = 'Fieldset';
Fieldset.identifier = Fieldset.displayName; // used in docs website

Fieldset.clonableProps = SYSTEM_PROPS;
export default Fieldset;